export default __webpack_public_path__ + "static/media/delete-question-grey.dd671930.svg";